const messageTranslations = {
  de: {
    loginError: "Login fehlgeschlagen",
    verifyEmail: "Bitte verifiziere deine Email. Hast du keine Email bekommen?",
    resendSuccess: "Verifikations-Email wurde erneut gesendet.",
    registerSuccess:
      "Registrierung erfolgreich - bitte verifiziere deine Email.",
    registerError:
      "Registrierung fehlgeschlagen - da ist wohl etwas schiefgelaufen.",
    subscription: {
      fetchError: "Fehler beim Abrufen der Abonnementdaten.",
      noActive: "Du hast aktuell kein aktives Abonnement.",
      portalError: "Fehler beim Erstellen der Portal Session.",
      cancelSuccess: "Abo-Kündigung erfolgreich.",
      cancelError: "Fehler beim Kündigen des Abos.",
      upgradeSuccess: "Abo-Upgrade erfolgreich.",
      upgradeError: "Fehler beim Upgrade des Abos.",
    },
    cloudinary: {
      uploadError: "Fehler beim Logo Upload.",
    },
    feedbackForm: {
      createSuccess: "Formular erfolgreich erstellt!",
      createError: "Fehler beim Erstellen des Formulars.",
      deleteSuccess: "Formular erfolgreich gelöscht!",
      deleteError: "Fehler beim Löschen des Formulars.",
      updateSuccess: "Formular erfolgreich aktualisiert!",
      updateError: "Fehler beim Aktualisieren des Formulars.",
      loadListError: "Fehler beim Laden der Formulare.",
      loadSingleError: "Fehler beim Laden des Formulars.",
    },
    feedback: {
      saveSuccess: "Feedback erfolgreich gespeichert.",
      saveError: "Fehler beim Speichern.",
      dashboardError: "Fehler beim Laden der Dashboard-Metriken.",
      overviewError: "Fehler beim Laden der KPI-Metriken.",
      chartError: "Fehler beim Laden der Diagramm-Metriken.",
    },
    notifications: {
      loadError: "Fehler beim Laden der Benachrichtigungen.",
      markError: "Fehler beim Markieren als gelesen.",
      markSuccess: "Benachrichtigungen als gelesen markiert.",
    },
    report: {
      successAggregate:
        "Aggregierter Bericht erfolgreich erstellt und heruntergeladen!",
      errorAggregate: "Fehler beim Erstellen des aggregierten Berichts.",
      successForm: "Formularbericht erfolgreich erstellt und heruntergeladen!",
      errorForm: "Fehler beim Erstellen des Formularberichts.",
      successAggregateKI: "KI-Gesamtbericht erfolgreich erstellt!",
      errorAggregateKI: "Fehler beim Erstellen des aggregierten KI-Berichts.",
      successFormKI: "KI-Formularbericht erfolgreich erstellt!",
      errorFormKI: "Fehler beim Erstellen des KI-Formularberichts.",
      loadReportsError: "Fehler beim Abrufen der Reports.",
      loadKISuggestionsError: "Fehler beim Abrufen der KI-Vorschläge.",
      loadSavedKISuggestionsError:
        "Gespeicherte KI-Vorschläge konnten nicht geladen werden.",
    },
    support: {
      createSuccess: "Support-Ticket wurde erfolgreich erstellt.",
      createError: "Support-Ticket konnte nicht erstellt werden.",
      loadError: "Fehler beim Abrufen der Support-Tickets.",
      updateSuccess: "Ticket erfolgreich aktualisiert.",
      updateError: "Fehler beim Aktualisieren des Tickets.",
    },
    qr: {
      createSuccess: "QR-Code wurde erfolgreich erstellt.",
      createError: "Fehler beim Erstellen des QR-Codes.",
      loadError: "Fehler beim Laden der QR-Codes.",
      editSuccess: "QR-Code wurde erfolgreich aktualisiert.",
      editError: "Fehler beim Bearbeiten des QR-Codes.",
      deleteSuccess: "QR-Code wurde erfolgreich gelöscht.",
      deleteError: "Fehler beim Löschen des QR-Codes.",
    },
  },
  en: {
    loginError: "Login failed",
    verifyEmail: "Please verify your email. Didn't receive an email?",
    resendSuccess: "Verification email has been resent.",
    registerSuccess:
      "Registration successful - please verify your email before logging in.",
    registerError: "Registration failed - something went wrong.",
    subscription: {
      fetchError: "Error while retrieving subscription data.",
      noActive: "You currently have no active subscription.",
      portalError: "Error creating portal session.",
      cancelSuccess: "Subscription successfully cancelled.",
      cancelError: "Error cancelling subscription.",
      upgradeSuccess: "Subscription successfully upgraded.",
      upgradeError: "Error upgrading subscription.",
    },
    cloudinary: {
      uploadError: "Error uploading logo.",
    },
    feedbackForm: {
      createSuccess: "Form created successfully!",
      createError: "Failed to create form.",
      deleteSuccess: "Form deleted successfully!",
      deleteError: "Failed to delete form.",
      updateSuccess: "Form updated successfully!",
      updateError: "Failed to update form.",
      loadListError: "Failed to load forms.",
      loadSingleError: "Failed to load form.",
    },
    feedback: {
      saveSuccess: "Feedback saved successfully.",
      saveError: "Failed to save feedback.",
      dashboardError: "Failed to load dashboard metrics.",
      overviewError: "Failed to load overview KPIs.",
      chartError: "Failed to load chart metrics.",
    },
    notifications: {
      loadError: "Failed to load notifications.",
      markError: "Failed to mark notifications as read.",
      markSuccess: "Notifications marked as read.",
    },
    report: {
      successAggregate:
        "Aggregated report generated and downloaded successfully!",
      errorAggregate: "Error generating aggregated report.",
      successForm: "Form report generated and downloaded successfully!",
      errorForm: "Error generating form report.",
      successAggregateKI: "AI aggregated report generated successfully!",
      errorAggregateKI: "Error generating AI aggregated report.",
      successFormKI: "AI form report generated successfully!",
      errorFormKI: "Error generating AI form report.",
      loadReportsError: "Error fetching reports.",
      loadKISuggestionsError: "Error fetching AI suggestions.",
      loadSavedKISuggestionsError: "Failed to load saved AI suggestions.",
    },
    support: {
      createSuccess: "Support ticket successfully created.",
      createError: "Failed to create support ticket.",
      loadError: "Error fetching support tickets.",
      updateSuccess: "Ticket updated successfully.",
      updateError: "Error updating the ticket.",
    },
    qr: {
      createSuccess: "QR code created successfully.",
      createError: "Error creating the QR code.",
      loadError: "Error loading QR codes.",
      editSuccess: "QR code updated successfully.",
      editError: "Error editing the QR code.",
      deleteSuccess: "QR code deleted successfully.",
      deleteError: "Error deleting the QR code.",
    },
  },
};

export default messageTranslations;
